@if(dialogType === 1) {
    <div class="dialog">
    <h2 mat-dialog-title><b>{{newSerialDialogTitle}}</b></h2>
    <div class="dialog-content">
        <mat-dialog-content>
        <div>
            <span class="input-title">{{newSerialInputTitle}}</span>
            <serial-search (serialCheck)="onSerialCheck($event)"></serial-search>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
        <button mat-button (click)="onCancel()" class="cancel-btn">{{ cancelButtonText }}</button>
        <button mat-button (click)="onConfirm()" class="confirm-btn" [disabled]="!validSerial">
            {{ startButtonText }}</button>
        </mat-dialog-actions>
    </div>
    </div>
} @if( dialogType === 2) {
    <div class="dialog">
        <h2 mat-dialog-title><b>{{photoAttachTitle}}</b> {{optionalText}}</h2>
        <div class="dialog-messages">
            <div class="photo-message">{{photoAttachMessage}}</div>
            <div class="file-type-message">{{fileTypeMessage}}</div>
        </div>
        <div class="photo-action-container">
            <div class="photo-actions">
                <div>{{addNewPhotoText}}</div>
                <button mat-button class="photo-btn" (click)="takePhoto()">
                    <mat-icon class="add-photo-icon">add_a_photo</mat-icon>
                </button>
            </div>
            <div class="photo-actions">
                <div>{{uploadPhotoText}}</div>
                <button mat-button class="photo-btn" (click)="uploadPhoto()">
                    <mat-icon class="upload-photo-icon">add_photo_alternate</mat-icon>
                </button>
            </div>
        </div>

        @if(photosAttached) {
            <div class="attached-photos">
                @for(photo of attachedPhotos; track photo.name) {
                <div class="attached-photo">
                    <div>{{photo.name}}.{{photo.fileType}}</div> <div>{{photo.size}}</div> 
                    <button mat-button class="remove-photo-btn" 
                    (click)="removePhoto(photo)">
                        <mat-icon class="remove-photo-icon">close</mat-icon>
                    </button>
                </div>
                }
            </div>
        }

        <div class="signoff-btns">
            <button mat-button (click)="onCancel()" class="cancel-btn">{{ cancelButtonText }}</button>
            <button mat-button (click)="savePhotos(attachedPhotos)" class="confirm-btn" [disabled]="!photosAttached">
                {{ startButtonText }}</button>
        </div>
    </div>
} @if(dialogType === 3) {
    <div>
    <h2 mat-dialog-title><b>{{odDefectTitle}}</b></h2>
    <div>
        <mat-dialog-content class="defect-dialog-style">
            <div class="defect-msg">{{odDefectMessage}}</div>
            <div>
                <dropdown-component 
                [dropdownType]="'defect'" 
                [observedDefectTasks]="observedDefectList" 
                (defectSelected)="onDefectSelected($event)">
                </dropdown-component>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
        <button mat-button (click)="onCancel()" class="cancel-btn">{{ cancelButtonText }}</button>
        <button mat-button (click)="onConfirm()" class="confirm-btn" [disabled]="!selectedDefectTask">
            {{ confirmButtonText }}</button>
        </mat-dialog-actions>
        </div>
    </div>
} @if(dialogType === 4) {
    <div class="signoff-dialog">
        <h2 mat-dialog-title><b>{{finalSignOffTitle}}</b></h2>
        <div class="signature-content">
            <div class="signoff-msg">
                <span>{{ finalSignOffMessage }}</span>
            </div>
            <div class="signature-box">
                <div class="signature-area">
                @if(isSignatureGenerated) {
                    <span class="signature">{{ signature }}</span>
                }
                </div>
            <hr class="signature-line">
                <span class="label">{{ finalSignOffPlaceholder }}</span>
                <mat-checkbox class="sign-chkbox"
                    [checked]="isSignatureGenerated"
                    (change)="generateSignature($event)">
                </mat-checkbox>
            </div>
        </div>

        <div class="signoff-btns">
            <button mat-button (click)="onCancel()" class="cancel-btn">{{ cancelButtonText }}</button>
            <button mat-button (click)="onConfirm()" class="confirm-btn" [disabled]="!isSignatureGenerated">
                {{ confirmButtonText }}</button>
        </div>
    </div>
} @if(dialogType === 5) {
    <div class="station-dialog">
    <h2 mat-dialog-title><b>{{designateTitle}}</b></h2>
    <div>
        <mat-dialog-content class="defect-dialog-style">
            <div class="dropdown-container">
                <dropdown-component 
                    [dropdownType]="'station'"
                    [stations]="dialogData.dataList"
                    (stationSelected)="onStationSelected($event)">
                </dropdown-component>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
        <button mat-button (click)="onCancel()" class="cancel-btn">{{ cancelButtonText }}</button>
        <button mat-button (click)="onConfirm()" class="confirm-btn" [disabled]="!selectedStation">
            {{ startButtonText }}</button>
        </mat-dialog-actions>
        </div>
    </div>
}